<template>
  <div class="wrapper wrapper_pc">
<!--    <common-nav :options="options" @showLoginDialog="showLoginDialog" @loginOut="loginOut" @accountCancel="accountCancel"></common-nav>-->

    <div id="mainSwiper">
      <div class="hms_login_banner" id="newGame">
        <div class="hms_center">
          <home-swiper
            :options="options"
            :swiperList="swiperList"
            class="animate__animated animate__fadeInLeft"
          ></home-swiper>
  <!--        <home-login-->
  <!--          :options="options"-->
  <!--          @thirdLoginDialog="thirdLoginDialog"-->
  <!--          class="animate__animated animate__fadeInRight"-->
  <!--        ></home-login>-->
        </div>
      </div>

      <div class="middle_banner flexCenter">
        <left-swiper :options="options"
        :swiperList="leftSwiperList"
        class="animate__animated animate__fadeInLeft"></left-swiper>
        <right-swiper :options="options"
                     :swiperList="rightSwiperList"
                     class="animate__animated animate__fadeInRight"></right-swiper>
      </div>
    </div>

    <home-game :options="options" :homeGamesList="homeGamesList"></home-game>
    <home-partners></home-partners>
    <slider-bar></slider-bar>
    <common-mask :options="options" @closeDialog="closeDialog"></common-mask>

    <fb-dialog
      :options="options"
      :isFbDialog="isFbDialog"
      :gamesList="gamesList"
      :platFormType="platFormType"
      @closeFbDialog="closeFbDialog"
    ></fb-dialog>
    <loading :options="options"></loading>
    <login-modal :options="options"
                 :isLoginDialog="isLoginDialog"
                 :gamesList="gamesList"
                 :platFormType="platFormType"
                 @closeLoginModel="closeLoginModel"></login-modal>
    <account-cancel
      v-if="showAccountCancel"
      :show_account_cancel="showAccountCancel"
      @closeDialog="closeCancelDialog"
    />
  </div>
</template>

<script>
import CommonMask from "../components/common/CommonMask.vue";
import CommonNav from "../components/common/CommonNav.vue";
import Loading from "../components/common/Loading";
import LoginModal from "../components/common/LoginModal.vue";
import HomeGame from "../components/home/HomeGame.vue";
import HomeLogin from "../components/home/HomeLogin.vue";
import HomePartners from "../components/home/HomePartners.vue";
import HomeSwiper from "../components/home/HomeSwiper.vue";
import LeftSwiper from "../components/home/LeftSwiper.vue";
import RightSwiper from "../components/home/RightSwiper.vue";
import AccountCancel from "../components/memberCenter/AccountCancel.vue";
import FbDialog from "../components/memberCenter/FbDialog.vue";
import SliderBar from "../components/sliderBar/index.vue";

export default {
  name: "Home",
  data: function () {
    return {
      platFormType: "",
      gamesList: [],
      homeGamesList: [],
      swiperList: [],
      leftSwiperList:[],
      rightSwiperList:[],
      isFbDialog: false,
      isLoginDialog: false,
      options: {
        isGameani: true,
        isnswiper: false,
        isMask: false,
        isnlist: false,
        isLoading: false,
        isHmsLogin: true,
      },
      showAccountCancel: false,
    };
  },
  components: {
    AccountCancel,
    SliderBar,
    CommonNav,
    HomeSwiper,
    LeftSwiper,
    RightSwiper,
    HomeGame,
    HomePartners,
    HomeLogin,
    FbDialog,
    CommonMask,
    Loading,
    LoginModal
  },
  inject: ["reload"],
  mounted() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.options.isFootani = true;
    } else {
      window.addEventListener("scroll", this.handleScroll);
    }
    this.thirdLogin();
    this.getSwiperList();
    this.getHomeGamesList();
    this.getLeftSwiperList()
    this.getRightSwiperList()
    if (localStorage.getItem("token")) {
      this.options.isHmsLogin = false;
    }
  },
  methods: {
    closeDialog: function () {
      this.options.isMask = false;
      this.isFbDialog = false;
    },
    closeFbDialog: function () {
      this.isFbDialog = false;
      this.options.isMask = false;
    },
    closeLoginModel: function () {
      this.isLoginDialog = false;
      this.options.isMask = false;
    },
    closeCancelDialog(val) {
      this.showAccountCancel = val;
    },
    // 首页顶部banner
    getSwiperList: function () {
      this.getHttp(this, "", "/front/home/banner", function (obj, data) {
        if (data.status === 2000) {
          obj.swiperList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    // 大武道-首页中间左侧banner
    getLeftSwiperList: function () {
      const datas = {
        // game_id:'', //没有明确的game_id,直接不传值
        platform:1, //1-PC,2-MB
        position: 8,
      };
      this.getHttp(this, datas, "/front/home/position/banner", function (obj, data) {
        if (data.status === 2000) {
          obj.leftSwiperList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    // 大武道-首页中间右侧banner
    getRightSwiperList: function () {
      const datas = {
        // game_id:'',// game_id:'', 没有明确的game_id,直接不传值
        platform:1,
        position: 9,
      };
      this.getHttp(this,datas, "/front/home/position/banner", function (obj, data) {
        if (data.status === 2000) {
          obj.rightSwiperList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    getHomeGamesList: function () {
      this.getHttp(this, "", "/front/home/games", function (obj, data) {
        if (data.status === 2000) {
          obj.homeGamesList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    getAllGamesList: function () {
      this.getHttp(this, "", "/front/game/all", function (obj, data) {
        if (data.status === 2000) {
          obj.gamesList = data.data;
          obj.firstGameId = data.data[0].id;
        }
      });
    },
    // self-login
    showLoginDialog: function () {
      this.options.isMask = true;
      this.isLoginDialog = true;
    },
    // 注销账户
    accountCancel:function (){
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("請先登錄帳號");
      } else {
        this.showAccountCancel = true;
      }
    },
    loginOut: function () {
      this.options.isLoading = true;
      this.options.isLoading = false;
      this.$store.commit("setIsHmsLogin", true);
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      this.$toast("已登出");
      this.$router.push({ path: "/home" });
      this.$store.commit("loginOut");
    },
    thirdLoginDialog: function (type) {
      this.isFbDialog = true;
      this.getAllGamesList();
      this.platFormType = type;
      this.options.isMask = true;
    },
    thirdLogin: function () {
      // 三方登录接口
      this.options.isLoading = true;
      this.account = this.$utils.getUrlKey("account");
      this.name = this.$utils.getUrlKey("name");
      this.token = this.$utils.getUrlKey("token");
      this.type = this.$utils.getUrlKey("type");
      this.signature = this.$utils.getUrlKey("signature");
      if (this.account && this.name && this.token && this.type) {
        let datas = {
          account: this.account,
          name: this.name,
          token: this.token,
          type: this.type,
        };
        this.postHttp(this, datas, "/front/others/login", function (obj, data) {
          if (data.status === 2000) {
            obj.options.isLoading = false;
            obj.options.isMask = false;

            let token = data.data.bear_token;
            let userInfo = data.data.user_info;
            obj.$store.commit("setToken", token);
            obj.$store.commit("setUserInfo", userInfo);
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            obj.options.isHmsLogin = false;
            obj.$store.commit("setIsHmsLogin", false);
          } else {
            obj.options.isLoading = false;
          }
          obj.$toast(data.message);
        });
      } else {
        this.options.isLoading = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrapper {
  //width: 100%;
  //background: #fff;
}

.middle_banner{
  width: 1400px;
  margin: 0 auto;
}

.hms_login_banner {
  width: 100%;
  height: 447px;
  //background: #dcdcdc;

  .hms_center {
    width: 1400px;
    margin: 0 auto;
  }
}

.center_bg {
  position: relative;
  width: 100%;
}

/* 全局动画速度加快 */
.animate__animated {
  animation-duration: 0.5s !important;
  transition-duration: 0.5s !important;
}
</style>
